import { StatusBadge } from "../../UI/StatusBadge.tsx";
import {
  FeedbackState,
  feedbackStateLabels,
} from "./onboardingLivesTableState.ts";

export function OnboardingLiveFeedbackBadge({
  state,
}: {
  state: FeedbackState;
}) {
  return (
    <StatusBadge
      tone={state === "sent" ? "success" : "warning"}
      label={feedbackStateLabels[state]}
    />
  );
}
